import React, { useEffect } from 'react';
import bem from 'utils/bem';
import { useFormikContext } from 'formik';
import Text from 'components/Text';
import { Button } from 'components/Button';
import UserAgreementCheckboxField from 'forms/fields/UserAgreementCheckboxField';
import PaymentField from 'forms/fields/PaymentField';
import Icon from 'components/Icon';
import PaymentBalanceField from "forms/fields/PaymentBalanceField";
import UserFields from './UserFields';
import Summary from './Summary';
import KZNotEnoughBalance from 'components/KZNotEnoughBalance';
import Model from '../../../../model';
import './index.sass';
import { whatsAppContacts } from 'components/AddressAndPhones';
import { ForeignCardWidget } from 'components/ForeignCardWidget';

const { block, el } = bem('course-form');

export default ({ price, title, ...form }) => {

    const { setFieldValue } = useFormikContext();
    const { isKZ, kzNotEnoughBalance } = Model.kz;

    useEffect(() => {
        setFieldValue('price', price);
    }, [ price ]);

    return <form className={ block() } onSubmit={ form.handleSubmit }>
        <div className={ el('title') }>
            <Text serif>{ title }</Text>
        </div>
        <div className={ el('fields') }>
            <div className={ el('user-fields') }>
                <UserFields/>
            </div>
            { !isKZ && <div className={ el('payment') }>
                <div className={ el('payment-title') }>
                    <Text>Способы оплаты</Text>
                </div>
                <PaymentField/>
            </div> }
            <div className={ el('payment-balance') }>
                <PaymentBalanceField className={ el('balance') } price={ price } mod={ 'long' }/>
            </div>
            <KZNotEnoughBalance price={ price }/>
            <div className={ el('details') }>
                <Icon name={ 'info' }/>
                <div>
                    <Text tag={ 'div' }>В течение 30 минут после оплаты доступ появится в личном кабинете в разделе
                        "Курсы".</Text>
                    <Text tag={ 'div' }>Если Вы пытаетесь оплатить не из России или картой не российского банка,
                        свяжитесь с нами <a target="__blank" href={ whatsAppContacts.link }>здесь</a></Text>
                </div>
            </div>
            { window.isRuDomain && <ForeignCardWidget /> }
            <div className={ el('summary') }>
                <Summary price={ price }/>
            </div>
            <div className={ el('footer') }>
                <UserAgreementCheckboxField name="acceptConditions"/>
                <Button
                    type={ 'submit' }
                    mod="gold"
                    disabled={ form.isSubmitting || kzNotEnoughBalance(price) }>
                    Оплатить
                </Button>
            </div>
        </div>
    </form>;
}
